(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card-color-split"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.lmdsColorSplitCards) return;
    window.lmdsColorSplitCards = true;

    function cardOf(node) {
      return node.closest ? node.closest('product-card.product-card') : null;
    }

    function snapshot(card) {
      if (card._csDefault) return card._csDefault;
      var img = card.querySelector('.card-gallery img');
      var name = card.querySelector('.cs-product-name');
      var price = card.querySelector('.cs-price');
      var link = card.querySelector('a[href]');
      card._csDefault = {
        src: img ? img.getAttribute('src') : null,
        srcset: img ? img.getAttribute('srcset') : null,
        alt: img ? img.getAttribute('alt') : null,
        url: link ? link.getAttribute('href') : null,
        variant: card.querySelector('.lmds-quick-add input[name="id"]') ? card.querySelector('.lmds-quick-add input[name="id"]').value : null,
        label: name ? name.textContent : null,
        priceHtml: price ? price.innerHTML : null,
        button: card.querySelector('.cs-swatch-wrap--active')
      };
      card._csSelected = card._csDefault;
      return card._csDefault;
    }

    function fromButton(button) {
      return {
        src: button.dataset.csSrc || null,
        srcset: button.dataset.csSrcset || null,
        alt: button.dataset.csAlt || null,
        url: button.dataset.csUrl || null,
        variant: button.dataset.csVariant || null,
        label: button.dataset.csLabel || null,
        priceText: button.dataset.csPrice || null,
        button: button
      };
    }

    function apply(card, state) {
      var img = card.querySelector('.card-gallery img');
      if (img && state.src) {
        if (state.srcset) img.setAttribute('srcset', state.srcset);
        img.setAttribute('src', state.src);
        if (state.alt) img.setAttribute('alt', state.alt);
        img.removeAttribute('loading');
      }
      if (state.url) {
        card.querySelectorAll('a[href]').forEach(function (a) {
          a.setAttribute('href', state.url);
        });
      }
      var qaInput = card.querySelector('.lmds-quick-add input[name="id"]');
      if (qaInput && state.variant) qaInput.value = state.variant;
      var name = card.querySelector('.cs-product-name');
      if (name && state.label) name.textContent = state.label;
      var hidden = card.querySelector('.product-card__link .visually-hidden');
      if (hidden && state.label) hidden.textContent = state.label;
      var price = card.querySelector('.cs-price');
      if (price) {
        if (state.priceHtml != null) {
          price.innerHTML = state.priceHtml;
        } else if (state.priceText) {
          price.classList.remove('price-with-badge');
          price.innerHTML = '';
          var span = document.createElement('span');
          span.className = 'price';
          span.textContent = state.priceText;
          price.appendChild(span);
        }
      }
      card.querySelectorAll('.cs-swatch-wrap').forEach(function (el) {
        var active = el === state.button;
        el.classList.toggle('cs-swatch-wrap--active', active);
        if (el.tagName === 'BUTTON') el.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function preload(card) {
      if (card._csPreloaded) return;
      card._csPreloaded = true;
      var img = card.querySelector('.card-gallery img');
      card.querySelectorAll('button.cs-swatch-wrap[data-cs-src]').forEach(function (button) {
        var pre = new Image();
        if (img && img.sizes) pre.sizes = img.sizes;
        if (button.dataset.csSrcset) pre.srcset = button.dataset.csSrcset;
        pre.src = button.dataset.csSrc;
      });
    }

    document.addEventListener('mouseover', function (event) {
      var card = cardOf(event.target);
      if (!card || !card.querySelector('button.cs-swatch-wrap')) return;
      snapshot(card);
      preload(card);
      var button = event.target.closest('button.cs-swatch-wrap');
      if (button && card.contains(button)) apply(card, fromButton(button));
    });

    document.addEventListener('mouseout', function (event) {
      var card = cardOf(event.target);
      if (!card || !card._csSelected) return;
      if (event.relatedTarget && card.contains(event.relatedTarget)) return;
      apply(card, card._csSelected);
    });

    document.addEventListener('click', function (event) {
      var button = event.target.closest ? event.target.closest('button.cs-swatch-wrap') : null;
      if (!button) return;
      var card = cardOf(button);
      if (!card) return;
      event.preventDefault();
      event.stopPropagation();
      snapshot(card);
      var state = button === card._csDefault.button ? card._csDefault : fromButton(button);
      card._csSelected = state;
      apply(card, state);
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
